// App.js (CORRECTED version)
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import Home from './components/Home';
import Footer from './components/Footer';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsofService';
import ContentPolicy from './components/ContentPolicy';
import Disclaimer from './components/Disclaimer';
import AboutUs from './components/About';
import CookiePolicy from './components/CookiePolicy';
import WaldoAd from './components/AdComponent';

import { calculatorRoutes } from './routes';

// Create lazy-loaded component wrapper
const CalculatorRoute = ({ componentName, title, description, keywords }) => {
  const CalculatorComponent = lazy(() => import(`./components/Pages/${componentName}`));
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <CalculatorComponent />
      </Suspense>
      <WaldoAd />
    </>
  );
};

// Loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Loading calculator...</p>
  </div>
);

// Static route components - FIXED!
const HomeRoute = () => (
  <>
    <Helmet>
      <title>AfterTaxPay.net - Free Payroll Calculators & Salary Tools</title>
      <meta name="description" content="AfterTaxPay.net offers free payroll calculators and salary tools to help you calculate net salary, taxes, and deductions for various countries." />
      <meta name="keywords" content="payroll calculator, salary calculator, net salary, tax calculator, online payroll, AfterTaxPay" />
    </Helmet>
    <Home />
  </>
);

const ContactRoute = () => (
  <>
    <Helmet>
      <title>Contact Us - AfterTaxPay.net</title>
      <meta name="description" content="Get in touch with AfterTaxPay.net for inquiries, feedback, or support. Our team is here to help with all your payroll and tax calculator questions." />
      <meta name="keywords" content="contact AfterTaxPay, customer support, inquiries, feedback, payroll calculator help, tax calculator support" />
    </Helmet>
    <Contact />
  </>
);

// FIXED: Using the correct components
const PrivacyPolicyRoute = () => (
  <>
    <Helmet>
      <title>Privacy Policy - AfterTaxPay.net</title>
      <meta name="description" content="Read the Privacy Policy of AfterTaxPay.net to understand how we collect, use, and protect your data while using our tax calculators and tools." />
      <meta name="keywords" content="privacy policy, data protection, AfterTaxPay.net, user privacy, website privacy policy" />
    </Helmet>
    <PrivacyPolicy /> {/* FIXED: was <Contact /> */}
  </>
);

const TermsOfServiceRoute = () => (
  <>
    <Helmet>
      <title>Terms of Service - AfterTaxPay.net</title>
      <meta name="description" content="Read the Terms of Service of AfterTaxPay.net to understand the rules, responsibilities, and legal agreements for using our tax calculators and financial tools." />
      <meta name="keywords" content="terms of service, user agreement, AfterTaxPay.net, website terms, legal terms" />
    </Helmet>
    <TermsOfService /> {/* FIXED: was <Contact /> */}
  </>
);

const DisclaimerRoute = () => (
  <>
    <Helmet>
      <title>Disclaimer - AfterTaxPay.net</title>
      <meta name="description" content="Read the Disclaimer of AfterTaxPay.net to understand the limitations, accuracy, and responsibilities regarding the use of our tax calculators and financial tools." />
      <meta name="keywords" content="disclaimer, tax tools disclaimer, AfterTaxPay.net, liability, accuracy of information" />
    </Helmet>
    <Disclaimer /> {/* FIXED: was <Contact /> */}
  </>
);

const ContentPolicyRoute = () => (
  <>
    <Helmet>
      <title>Content Policy - AfterTaxPay.net</title>
      <meta name="description" content="Read the Content Policy of AfterTaxPay.net to understand the guidelines for using and sharing content on our website, including tax calculators and financial tools." />
      <meta name="keywords" content="content policy, website content guidelines, AfterTaxPay.net, content usage, content rules" />
    </Helmet>
    <ContentPolicy /> {/* FIXED: was <Contact /> */}
  </>
);

const AboutUsRoute = () => (
  <>
    <Helmet>
      <title>About Us - AfterTaxPay.net</title>
      <meta name="description" content="Learn more about AfterTaxPay.net, our mission, team, and how we provide accurate tax calculators and financial tools to help users manage their finances." />
      <meta name="keywords" content="About AfterTaxPay.net, tax tools team, financial tools, company information, About Us" />
    </Helmet>
    <AboutUs /> {/* FIXED: was <Contact /> */}
  </>
);

const CookiePolicyRoute = () => (
  <>
    <Helmet>
      <title>Cookie Policy - AfterTaxPay.net</title>
      <meta name="description" content="Read the Cookie Policy of AfterTaxPay.net to understand how we use cookies and similar technologies to improve your experience and provide personalized content." />
      <meta name="keywords" content="Cookie Policy, AfterTaxPay.net cookies, website cookies, privacy, cookie usage, cookie management" />
    </Helmet>
    <CookiePolicy /> {/* FIXED: was <Contact /> */}
  </>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Static Routes */}
              <Route path="/" element={<HomeRoute />} />
              <Route path="/contact" element={<ContactRoute />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicyRoute />} />
              <Route path="/TermsOfService" element={<TermsOfServiceRoute />} />
              <Route path="/Disclaimer" element={<DisclaimerRoute />} />
              <Route path="/ContentPolicy" element={<ContentPolicyRoute />} />
              <Route path="/AboutUs" element={<AboutUsRoute />} />
              <Route path="/CookiePolicy" element={<CookiePolicyRoute />} />
              
              {/* Dynamic Calculator Routes */}
              {calculatorRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <CalculatorRoute
                      componentName={route.component}
                      title={route.title}
                      description={route.description}
                      keywords={route.keywords}
                    />
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;